import React, {useEffect, useState} from 'react'
import {Button, Col, Row} from "react-bootstrap";
import {bindActionCreators} from "redux";
import * as actions from './JSAFormLogsApi'
import {connect} from "react-redux";
import PageHeader from "../../../components/PageTitle";
import {BootstrapTable, SizePerPageDropDown, TableHeaderColumn} from "react-bootstrap-table";
import _ from 'lodash'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import JSAModal from './JSA/JSAModal';
import ExcelJS from "exceljs";
import moment from "moment";
import {defaultDateFormat} from "../../../common/commonHandlers";
import {saveAs} from "file-saver";
import JSAFilterModal from "./JSA/JSAFilterModal";

const JSAFormLogs = ({actions, client}) => {
        const [JSALogs, setJSALogs] = useState([])
        const [servicesTypeList, setServicesTypeList] = useState([])
        const [page, setPage] = useState(1)
        const [per_page, setPer_page] = useState(25)
        const [sort, setSort] = useState({sortName: 'modified_at', sortOrder: 'desc'})
        const [total, setTotal] = useState(0)
        const [showFilterModal, setShowFilterModal] = useState(false)
        const [serviceType, setServiceType] = useState(null)
        const [filters, setFilters] = useState({
            customerIds: [],
            workOrderIds: [],
            proposalIds: [],
        })

        const loadJSALogs = (newFilters = null) => {
            const feedbackFilters = _.cloneDeep(newFilters ? newFilters : filters)
            feedbackFilters.customerIds = feedbackFilters.customerIds.map(f => f.value)
            feedbackFilters.workOrderIds = feedbackFilters.workOrderIds.map(f => f.value)
            feedbackFilters.proposalIds = feedbackFilters.proposalIds.map(f => f.value)

            actions.getJSALogs(page, per_page, feedbackFilters, sort, res => {
                setJSALogs(res.data)
                setTotal(res.total || 0)
            })
        }

        const loadServicesList = () => {
            actions.getServicesTypeList(res => {
                setServicesTypeList(res)
            })
        }

        const loadJsaForm = (id) => {
            if (id) {
                actions.getJsaForm(id, res => {
                    setServiceType(res)
                })
            }
        }
        const dataFormatter = (cell, tableFormat = false) => {
            if (!cell) return '';

            const parts = [];

            if (cell.work_plan?.length > 0) {
                const workPlanItems = cell.work_plan
                    .filter(item => item.name || item.task)
                    .map((item, index) => `${index + 1}. ${item.name} / ${item.task}`)
                    .join(', ');
                if (workPlanItems) {
                    parts.push(workPlanItems);
                }
            }

            if (cell.answers?.length > 0) {
                parts.push(cell.answers.join(', '));
            }

            if (cell.text_answers?.length > 0) {
                parts.push(cell.text_answers.join(', '));
            }

            if (cell.yes_no_section?.length > 0) {
                parts.push(cell.yes_no_section.join(', '));
            }

            if (tableFormat) {
                return parts.join('<br />');
            } else {
                return parts.join('\n');
            }
        };
        const dateFormatter = (cell, tableFormat = false) => {
            if (!cell) return '';

            const parts = [];
            if (cell.date) parts.push(`Date 1: ${new Date(cell.date).toLocaleDateString()}`);
            if (cell.date1) parts.push(`Date 2: ${new Date(cell.date1).toLocaleDateString()}`);
            if (cell.date2) parts.push(`Date 3: ${new Date(cell.date2).toLocaleDateString()}`);
            if (cell.initials) parts.push('Initials: ' + cell.initials);

            if (tableFormat) {
                return parts.join('<br />');
            } else {
                return parts.join('\n');
            }
        };

        const exportToXLSX = async () => {

            const data = _.cloneDeep(JSALogs)
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet("JSA Logs")

            let rows = [];

            data.forEach((item) => {
                rows.push([
                    item["service_type_name"],
                    dataFormatter(item["*JHA (fill out each section)"]),
                    dataFormatter(item["Common Hazards/Obstacles:"]),
                    dataFormatter(item["Countermeasures:"]),
                    dataFormatter(item["PPE:"]),
                    dataFormatter(item["Tree Hazards:"]),
                    dataFormatter(item["Work Plan (Name/Task):"]),
                    dateFormatter(item["summary"]),
                    moment(item["updated_at"]).format('YYYY-MM-DD HH:mm')
                ])
            })

            worksheet.addTable({
                name: 'JSA Logs',
                ref: 'A1',
                headerRow: true,
                style: {
                    theme: 'TableStyleMedium9',
                    showRowStripes: true,
                },
                columns: [
                    {name: 'Service Type', filterButton: true},
                    {name: '*JHA (fill out each section)', filterButton: true},
                    {name: 'Common Hazards/Obstacles', filterButton: true},
                    {name: 'Countermeasures', filterButton: true},
                    {name: 'PPE', filterButton: true},
                    {name: 'Tree Hazards', filterButton: true},
                    {name: 'Work Plan (Name/Task)', filterButton: false},
                    {name: 'Job Briefing/JHA Initials', filterButton: true},
                    {name: 'Update Date', filterButton: true},
                ],
                rows: rows,
            });

            worksheet.eachRow((row, rowNumber) => {
                if (rowNumber > 1) {
                    for (let col = 1; col <= 9; col++) {
                        row.getCell(col).style = {
                            alignment: {wrapText: true, vertical: "top"},
                            font: {name: 'Calibri', size: 8}
                        };
                    }
                    row.height = 60;
                }
            });

            worksheet.views = [
                {state: 'frozen', xSplit: 0, ySplit: 1, activeCell: 'A1'}
            ];

            worksheet.columns.forEach((column) => {
                let autoWidthColumns = [1, 2, 3, 4, 5, 6, 7, 8, 9]
                let colNumber = column._number
                if (autoWidthColumns.includes(colNumber)) {
                    column.width = autoColumnWidth(column);
                    if (column.width > 40) column.width = 40
                }
            })

            const excelBuffer = await workbook.xlsx.writeBuffer();

            const dataBlob = new Blob([excelBuffer], {type: 'application/octet-stream'});
            saveAs(dataBlob, `jsa-logs-${moment().format(defaultDateFormat)}.xlsx`);
        }

        const autoColumnWidth = (column) => {
            const lengths = column.values.map(v => v.toString().length);
            const maxLength = Math.max(...lengths.filter(v => typeof v === 'number')) * 0.727;
            return maxLength;
        }

        useEffect(() => {
            loadJSALogs()
        }, [page, per_page, sort])

        useEffect(() => {
            loadServicesList()
        }, []);

        const renderSizePerPageDropDown = () => {

            return (
                <SizePerPageDropDown
                    className='my-size-per-page'
                    variation='dropup'
                    currSizePerPage={per_page}
                />
            );
        };

        const onSortChange = (sortName, sortOrder) => {
            setSort({sortName: sortName, sortOrder: sortOrder})
        }

        const renderDesktopForm = () => {
            return <><Row className='vertical-align'>
                <Col xs={6}>
                    <Row>
                        <Col xs={12} className="d-flex">
                            <PageHeader pageName="JSA/JHA form logs" pageDetail={`${total} records`}/>
                        </Col>
                    </Row>
                </Col>
                <Col xs={6} className='text-right'>
                    <Button bsStyle="success"
                            className="mr-9"
                            onClick={() => exportToXLSX()}>Export to XLSX</Button>
                    <Button
                        className="mr-9"
                        bsStyle="warning"
                        onClick={() => setShowFilterModal(true)}
                    >
                        Filter {" "}<FontAwesomeIcon icon="search" className="small-margin"/>
                    </Button>
                    <Button
                        bsStyle="success"
                        onClick={() => loadJsaForm(servicesTypeList[0].id)}
                    >
                        Edit Form
                    </Button>
                </Col>
            </Row>
            </>
        }

        const renderMobileForm = () => {
            return <div className="mobile-jsa-form">
                <div className="header">
                    <PageHeader pageName="JSA/JHA form logs" pageDetail={`${total} records`}/>
                </div>
            </div>
        }

        const isMobile = window.screen.width < 768;

        return (
            <div id='jsa_logs'>
                {isMobile ? renderMobileForm() : renderDesktopForm()}
                <Col md={12} className="remaining no-padding">
                    <BootstrapTable
                        data={JSALogs}
                        key={page}
                        striped={true}
                        bordered={false}
                        hover={true}
                        pagination={true}
                        height={'auto'}
                        remote
                        fetchInfo={{dataTotalSize: total}}
                        options={{
                            onPageChange: (page, per_page) => {
                                setPage(page)
                                setPer_page(per_page)
                            },
                            page,
                            sizePerPageDropDown: renderSizePerPageDropDown,
                            sizePerPageList: [
                                {text: '10', value: 10},
                                {text: '25', value: 25},
                                {text: '30', value: 30},
                                {text: '50', value: 50},
                                {text: '100', value: 100},
                                {text: '200', value: 200}],
                            sizePerPage: per_page,
                            sortName: sort?.sortName,
                            sortOrder: sort?.sortOrder,
                            onSortChange: onSortChange
                        }}
                    >
                        <TableHeaderColumn hidden isKey dataField="id">
                            Id
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            tdStyle={{whiteSpace: 'normal', wordWrap: 'break-word'}}
                            thStyle={{textWrap: "pretty"}}
                            dataField="service_type_name"
                            dataSort
                            width={isMobile ? '200px' : '20%'}
                        >
                            Service Type
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            tdStyle={{whiteSpace: 'normal', wordWrap: 'break-word'}}
                            thStyle={{textWrap: "pretty"}}
                            dataField="*JHA (fill out each section)"
                            dataFormat={dataFormatter}
                            width={isMobile ? '200px' : '20%'}
                        >
                            *JHA (fill out each section)
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            tdStyle={{whiteSpace: 'normal', wordWrap: 'break-word'}}
                            thStyle={{textWrap: "pretty"}}
                            dataField="Common Hazards/Obstacles:"
                            dataFormat={dataFormatter}
                            width={isMobile ? '200px' : '20%'}
                        >
                            Common Hazards/Obstacles
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            tdStyle={{whiteSpace: 'normal', wordWrap: 'break-word'}}
                            thStyle={{textWrap: "pretty"}}
                            dataField="Countermeasures:"
                            dataFormat={dataFormatter}
                            width={isMobile ? '200px' : '20%'}
                        >
                            Countermeasures
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            tdStyle={{whiteSpace: 'normal', wordWrap: 'break-word'}}
                            thStyle={{textWrap: "pretty"}}
                            dataField="PPE:"
                            dataFormat={dataFormatter}
                            width={isMobile ? '200px' : '20%'}
                        >
                            PPE
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            tdStyle={{whiteSpace: 'normal', wordWrap: 'break-word'}}
                            thStyle={{textWrap: "pretty"}}
                            dataField="Tree Hazards:"
                            dataFormat={dataFormatter}
                            width={isMobile ? '200px' : '20%'}
                        >
                            Tree Hazards
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            tdStyle={{whiteSpace: 'normal', wordWrap: 'break-word'}}
                            thStyle={{textWrap: "pretty"}}
                            dataField="Work Plan (Name/Task):"
                            dataFormat={dataFormatter}
                            width={isMobile ? '200px' : '20%'}
                        >
                            Work Plan (Name/Task)
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            tdStyle={{whiteSpace: 'normal', wordWrap: 'break-word'}}
                            thStyle={{textWrap: "pretty"}}
                            dataField="summary"
                            dataFormat={dateFormatter}
                            width={isMobile ? '200px' : '20%'}
                        >
                            Job Briefing/JHA Initials
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            tdStyle={{whiteSpace: 'normal', wordWrap: 'break-word'}}
                            thStyle={{textWrap: "pretty"}}
                            dataField="updated_at"
                            dataSort
                            dataFormat={(cell) => moment(cell).format('YYYY-MM-DD HH:mm')}
                            width={isMobile ? '200px' : '20%'}
                        >
                            Update Date
                        </TableHeaderColumn>

                    </BootstrapTable>
                </Col>
                {serviceType && <JSAModal
                    serviceType={serviceType}
                    serviceTypeList={servicesTypeList}
                    onHide={() => setServiceType(null)}
                    onSave={actions.saveJsaForm}
                    onServiceChange={(id) => loadJsaForm(id)}
                />}
                {showFilterModal && <JSAFilterModal
                    startFilters={filters}
                    onHide={() => setShowFilterModal(false)}
                    onSave={filters => {
                        loadJSALogs(filters)
                        setFilters(filters)
                    }}
                    searchForCustomer={actions.searchForCustomer}
                    searchForWorkOrders={actions.searchForWorkOrders}
                    searchForProposals={actions.searchForProposals}
                    isJSAModal
                />}

            </div>
        );
    }
;

const mapStateToProps = state => (
    {
        name: state.auth.name,
        client: state.client.customerInfo,
    }
)

const mapDispatchToProps = dispatch => (
    {
        actions: bindActionCreators(actions, dispatch),
    }
)

export default connect(mapStateToProps, mapDispatchToProps)(JSAFormLogs)